export default function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}


//////////////////
// WEBPACK FOOTER
// ../~/css-vendor/~/@babel/runtime/helpers/esm/iterableToArray.js
// module id = 2580
// module chunks = 121